import React, { useState, useEffect, ReactElement, Suspense } from "react";

import axios from "axios";

import { useSelector } from "react-redux";

import AppAnalytics from "./components/analytics";
import Settings from "./components/settings";

import AppRoutes from "./routes/";

import { AuthProvider } from "./context/auth.context";
import { SplashScreenProvider } from "./context/splashScreen/splashScreen.context";

import { auth, storageBucket, storage } from "../src/apis/firebase";

const { REACT_APP_API_URL, REACT_APP_API_VERSION } = process.env;

axios.defaults.baseURL = `${REACT_APP_API_URL}/api/${REACT_APP_API_VERSION}`;

axios.defaults.headers.post["Content-Type"] = "application/json";

import { setupAxios } from "./redux/store";

setupAxios(axios);

import initializeTranslation from "./i18n";

import "./assets/scss/main.scss";

const App = (): ReactElement => {
  const [appInitialized, setAppInitialized] = useState(false);

  const { firebaseInitialized } = useSelector(({ firebase }) => ({
    firebaseInitialized: firebase.initialized,
  }));

  useEffect(() => {
    if (!auth && !storageBucket && !storage) return;
    setAppInitialized(!!auth);

    if (!!storageBucket && !!storage)
      initializeTranslation(storage, storageBucket);
  }, [firebaseInitialized]);

  return (
    <>
      {appInitialized && (
        <AuthProvider>
          <Suspense fallback={<></>}>
            <AppAnalytics />
            <Settings />
            <SplashScreenProvider>
              <AppRoutes />
            </SplashScreenProvider>
          </Suspense>
        </AuthProvider>
      )}
    </>
  );
};
export default App;
